/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventInvitationInfosUpdateRequest model module.
 * @module model/EventsControllerDtoEventInvitationInfosUpdateRequest
 * @version 1.0
 */
class EventsControllerDtoEventInvitationInfosUpdateRequest {
    /**
     * Constructs a new <code>EventsControllerDtoEventInvitationInfosUpdateRequest</code>.
     * @alias module:model/EventsControllerDtoEventInvitationInfosUpdateRequest
     */
    constructor() { 
        
        EventsControllerDtoEventInvitationInfosUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventInvitationInfosUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventInvitationInfosUpdateRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventInvitationInfosUpdateRequest} The populated <code>EventsControllerDtoEventInvitationInfosUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventInvitationInfosUpdateRequest();

            if (data.hasOwnProperty('invNo')) {
                obj['invNo'] = ApiClient.convertToType(data['invNo'], 'Number');
            }
            if (data.hasOwnProperty('invitationLimit')) {
                obj['invitationLimit'] = ApiClient.convertToType(data['invitationLimit'], 'Number');
            }
            if (data.hasOwnProperty('regDuration')) {
                obj['regDuration'] = ApiClient.convertToType(data['regDuration'], 'Number');
            }
            if (data.hasOwnProperty('inviterPer')) {
                obj['inviterPer'] = ApiClient.convertToType(data['inviterPer'], 'Number');
            }
            if (data.hasOwnProperty('inviterXper')) {
                obj['inviterXper'] = ApiClient.convertToType(data['inviterXper'], 'Number');
            }
            if (data.hasOwnProperty('inviterItem1')) {
                obj['inviterItem1'] = ApiClient.convertToType(data['inviterItem1'], 'Number');
            }
            if (data.hasOwnProperty('inviterItem1Count')) {
                obj['inviterItem1Count'] = ApiClient.convertToType(data['inviterItem1Count'], 'Number');
            }
            if (data.hasOwnProperty('inviterItem2')) {
                obj['inviterItem2'] = ApiClient.convertToType(data['inviterItem2'], 'Number');
            }
            if (data.hasOwnProperty('inviterItem2Count')) {
                obj['inviterItem2Count'] = ApiClient.convertToType(data['inviterItem2Count'], 'Number');
            }
            if (data.hasOwnProperty('invitedPer')) {
                obj['invitedPer'] = ApiClient.convertToType(data['invitedPer'], 'Number');
            }
            if (data.hasOwnProperty('invitedXper')) {
                obj['invitedXper'] = ApiClient.convertToType(data['invitedXper'], 'Number');
            }
            if (data.hasOwnProperty('invitedItem1')) {
                obj['invitedItem1'] = ApiClient.convertToType(data['invitedItem1'], 'Number');
            }
            if (data.hasOwnProperty('invitedItem1Count')) {
                obj['invitedItem1Count'] = ApiClient.convertToType(data['invitedItem1Count'], 'Number');
            }
            if (data.hasOwnProperty('invitedItem2')) {
                obj['invitedItem2'] = ApiClient.convertToType(data['invitedItem2'], 'Number');
            }
            if (data.hasOwnProperty('invitedItem2Count')) {
                obj['invitedItem2Count'] = ApiClient.convertToType(data['invitedItem2Count'], 'Number');
            }
            if (data.hasOwnProperty('initialXper')) {
                obj['initialXper'] = ApiClient.convertToType(data['initialXper'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('initialPer')) {
                obj['initialPer'] = ApiClient.convertToType(data['initialPer'], 'Number');
            }
            if (data.hasOwnProperty('rewardLimit')) {
                obj['rewardLimit'] = ApiClient.convertToType(data['rewardLimit'], 'Number');
            }
            if (data.hasOwnProperty('rewardRatio')) {
                obj['rewardRatio'] = ApiClient.convertToType(data['rewardRatio'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventInvitationInfosUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventInvitationInfosUpdateRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} invNo
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['invNo'] = undefined;

/**
 * @member {Number} invitationLimit
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['invitationLimit'] = undefined;

/**
 * @member {Number} regDuration
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['regDuration'] = undefined;

/**
 * @member {Number} inviterPer
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['inviterPer'] = undefined;

/**
 * @member {Number} inviterXper
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['inviterXper'] = undefined;

/**
 * @member {Number} inviterItem1
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['inviterItem1'] = undefined;

/**
 * @member {Number} inviterItem1Count
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['inviterItem1Count'] = undefined;

/**
 * @member {Number} inviterItem2
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['inviterItem2'] = undefined;

/**
 * @member {Number} inviterItem2Count
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['inviterItem2Count'] = undefined;

/**
 * @member {Number} invitedPer
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['invitedPer'] = undefined;

/**
 * @member {Number} invitedXper
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['invitedXper'] = undefined;

/**
 * @member {Number} invitedItem1
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['invitedItem1'] = undefined;

/**
 * @member {Number} invitedItem1Count
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['invitedItem1Count'] = undefined;

/**
 * @member {Number} invitedItem2
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['invitedItem2'] = undefined;

/**
 * @member {Number} invitedItem2Count
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['invitedItem2Count'] = undefined;

/**
 * @member {Number} initialXper
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['initialXper'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['endAt'] = undefined;

/**
 * @member {Number} initialPer
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['initialPer'] = undefined;

/**
 * @member {Number} rewardLimit
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['rewardLimit'] = undefined;

/**
 * @member {Number} rewardRatio
 */
EventsControllerDtoEventInvitationInfosUpdateRequest.prototype['rewardRatio'] = undefined;






export default EventsControllerDtoEventInvitationInfosUpdateRequest;

